<template>
  <ul v-if="block.data.element === 'ul'" class="block-list" :class="classes">
    <Blocks :blocks="block?.blocks" />
  </ul>
  <ol v-else class="block-list" :class="classes">
    <Blocks :blocks="block?.blocks" />
  </ol>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
  props.block?.data?.style ? props.block?.data?.style : null,
].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
.block-list {
  // @include box(blue);
}

ul, 
ol {
  @apply ml-6;
}

ul {
  @apply list-disc;
}

ol {
  @apply list-decimal;
}
</style>
